module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b526b27033d326971504252c8a64799f.png";